import React, { useState } from "react";
import ProcessBar from "../MainComponent/processBar";
import AnlyticsInfo from "./analyticsInfo";
import "./analytics.css";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";

export default function AnalyticsDetail() {
  const [emptyValues, setEmptyValues] = useState(false);
  // const projectId = sessionStorage.getItem("projectId");
 const projectId = useSelector((state) => state.roof.id);

  return (
    <>
      <div className="analyticsDetails">
        <div className="analyticsHead">
          <div className="analyticsHeader">
            <Link to="/Dashboard">
              <h6 style={{ color: "#FF7C1B" }}>My Project</h6>
            </Link>
            <h6>/</h6>
            {!projectId ? <h6>Create Project</h6> : <h6>Edit Project</h6>}
          </div>
          <ProcessBar setEmptyValues={setEmptyValues}></ProcessBar>
        </div>
        <AnlyticsInfo
          emptyValues={emptyValues}
          setEmptyValues={setEmptyValues}
        ></AnlyticsInfo>
      </div>
    </>
  );
}
